import { createStore } from 'vuex'
import auth from './modules/auth'
import researcher from './modules/researcher'

export default createStore({
  modules: {
    auth,
    researcher
  }
})
